import React from "react";
import UploadHeader from "../components/common/UploadHeader";
import PostUpdateForm from "../components/postUpdate";

const PostUpdate = () => {
  return (
    <>
      <UploadHeader />
      <PostUpdateForm />
    </>
  );
};

export default PostUpdate;
